import React, {Component} from 'react';
import {preUserregister} from './firebase';
import {Link, browserHistory} from 'react-router';

import './ga';
import ReactPixel from 'react-facebook-pixel';

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email:""
    }
  }

  // onload
  componentDidMount() {
    if ("/lp" === window.location.pathname) {
      ReactPixel.init('185828338818169');
      ReactPixel.pageView(); // For tracking page view
    }
  }



  handleChangeEmail(email) {
    this.setState({"email": email});
  }

  preRegist() {
    if (!this.state.email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
      console.log("メールアドレスを正しく入力してください");
    } else {
      // firebaseに登録
      preUserregister(this.state.email);
      ReactPixel.track( "CompleteRegistration" )
      browserHistory.push("/lpThanks");
    }
  }

  render() {
    return (
    <div>
      <div id="wrapper" className="wrapper-lp">
        <div className="header">
          <img className="header-title" src="/img/lp/logo_white.png" alt="" />
        </div>
        <div className="webWrap">
          <div className="wrapCover wrapCover-lp">
            <div className="wrapCover__lp-leadBlock clearfix">
              <div className="leadBlock-left">
                <img className="deviceImg__pc pc-only" src="/img/lp/img_device_pc.png" alt="" />
              </div>
              <div className="leadBlock-right">
                <div className="formBlock">
                  <p className="title">マイレートは、<br />オンラインの信頼証明書です。</p>
                  <p className="sub-title">ベータ版、この冬公開。</p>
                  <img className="deviceImg__sp sp-only" src="/img/lp/img_device_sp.png" alt="" />
                  <form>
                    <input className="mailForm" value={this.state.email} type="email" name="" placeholder="メールアドレス" onChange={(e) => {this.handleChangeEmail(e.target.value)}} />
                    <button className="submitForm" type="button" onClick={(e) => {this.preRegist(e)}}>お知らせを受け取る</button>
                  </form>
                </div>
              </div>
            </div>
            <div className="wrapCover__lp-contentBlock clearfix">
              <div className="contentService clearfix">
                <div className="contentService-left">
                  <div className="detailBlock">
                    <img className="serviceImg__1" src="/img/lp/img_service_1.png" alt="" />
                    <p className="title">MyRateが、<br />オンラインの信頼力を証明！</p>
                    <p className="text-detail">MyRateは身分証明書や電話番号の登録、オンラインでの取引履歴の連携によって、あなたのオンライン取引の信用度を見える化します.</p>
                  </div>
                </div>
                <div className="contentService-right">
                  <div className="detailBlock">
                    <img className="serviceImg__2" src="/img/lp/img_service_2.png" alt="" />
                    <p className="title">無料でMyRateを取得しよう!</p>
                    <p className="text-detail">フリマアプリなどのシェアリングエコノミーサービスにおける取引で信用力を証明して、取引相手に安心してもらいましょう。</p>
                  </div>
                </div>
              </div>
              <hr className="border" />
              <div className="contentService-bottom">
                <div className="formBlock-bottom">
                  <p className="title">先行登録受付中</p>
                  <p className="sub-title">ベータ版公開時にいち早くメールでお知らせいたします。</p>
                  <form>
                    <input className="mailForm" type="email" value={this.state.email} name="" placeholder="メールアドレス" onChange={(e) => {this.handleChangeEmail(e.target.value)}} />
                    <button className="submitForm" type="button" onClick={(e) => {this.preRegist(e)}}>お知らせを受け取る</button>
                  </form>
                </div>
              </div>
            </div>

            <div className="wrapCover__formBlock-lp-under">
              <Link to="http://www.n-village.co.jp/" target="_blank">
                <p className="f_copy">Produced by N-village</p>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/lp.js